import Carousel from './carousel'
import Col from 'react-bootstrap/lib/Col'
import LazyLoad from 'react-lazyload'
import ProductTile from '../bundle/client/components/product/tile'
import PropTypes from 'prop-types'
import React, {Fragment} from 'react'
import Row from 'react-bootstrap/lib/Row'
import chunk from 'lodash/chunk'
import {aspectRatio} from '../bundle/client/sharedStyles'
import {changeHost} from '../shared/utils'
import {colors, media, text} from '../styles'
import {css} from 'glamor'

const style = {
  carousel: css({
    margin: '0 -15px',
    '& > .carousel-control': {
      background: 'none',
      color: colors.grayLight,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      textShadow: 'none',
      width: '50px'
    }
  }),
  icon: css({
    color: colors.gray46
  }),
  productList: css({
    display: 'flex',
    justifyContent: 'space-around',
    listStyle: 'none',
    margin: '0 50px',
    padding: 0
  }),
  productRecommendation: css(text.finePrint, {
    textAlign: 'left',
    width: '160px',
    '& > a': {
      color: colors.defaultText,
      display: 'block',
      textDecoration: 'none',
      '& > h5': {
        margin: '5px 0 0'
      }
    },
    '& .image': {
      marginBottom: '20px',
      ...aspectRatio(1.3, 'img', {
        top: 0,
        width: '100%'
      })
    },
    '& .name': {
      color: colors.linkText,
      display: '-webkit-box',
      height: '44px',
      overflow: 'hidden',
      WebkitLineClamp: '3',
      WebkitBoxOrient: 'vertical'
    },
    '& .price': {
      fontWeight: '700'
    },
    ...media.xs({
      width: '120px'
    }),
    ...media.sm({
      width: '140px'
    })
  })
}

const RecommendationCarousel = ({imageHost, productRecommendations, store}) => (
  <Fragment>
    <Carousel
      iconKind="chevron"
      interval={null}
      indicators={false}
      iconTop="15%"
      className="hidden-xs"
    >
      {chunk(productRecommendations.slice(0, 12), 4).map((products, i) => (
        <Carousel.Item key={i}>
          <Row>
            {products.map((p, i) => (
              <Col key={i} sm={3}>
                <ProductTile
                  fullSize={false}
                  imageHost={imageHost}
                  imageStyle={style.carouselImage}
                  product={p}
                  store={store}
                >
                  <div className="image">
                    <LazyLoad height="100%" once placeholder={<img />}>
                      <img
                        src={changeHost(p.ImageUrl, imageHost)}
                        alt={p.Name}
                      />
                    </LazyLoad>
                  </div>
                </ProductTile>
              </Col>
            ))}
          </Row>
        </Carousel.Item>
      ))}
    </Carousel>
    <Carousel interval={null} controls={false} className="visible-xs">
      {chunk(productRecommendations.slice(0, 8), 2).map((products, i) => (
        <Carousel.Item key={i}>
          <Row>
            {products.map((p, i) => (
              <Col key={i} xs={6}>
                <ProductTile
                  fullSize={false}
                  imageHost={imageHost}
                  product={p}
                  store={store}
                >
                  <div className="image">
                    <LazyLoad height="100%" once placeholder={<img />}>
                      <img src={changeHost(p.ImageUrl, imageHost)} />
                    </LazyLoad>
                  </div>
                </ProductTile>
              </Col>
            ))}
          </Row>
        </Carousel.Item>
      ))}
    </Carousel>
  </Fragment>
)

RecommendationCarousel.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  imageHost: PropTypes.string,
  productRecommendations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  store: PropTypes.object.isRequired
}

export default RecommendationCarousel
